import { useState, useEffect } from 'react';
import './DemoMessages.css';
import { getCurrentUser, refresh } from '../../services/auth.service';
import { Link, useParams } from 'react-router-dom';
import { getInbox, refreshToken } from '../../utils/api';
import Spinner from '../../components/layout/Spinner';
import { useNavigate } from 'react-router-dom';
import { FaInbox } from 'react-icons/fa';
import ScrollToTop from '../../components/layout/ScrollToTop';
import { User } from 'lucide-react';

const DemoMessages = () => {
  let user = getCurrentUser();
  const [inbox, setInbox] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const imageUrl = process.env.REACT_APP_IMAGE_URL;
  const baseImageUrl = process.env.REACT_APP_BASE_IMAGE_URL;
  const navigate = useNavigate();
  const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true };

  // Function to display initials for avatar fallback
  const getInitials = (name = '') => {
    return name
      .split(' ')
      .map(n => n[0])
      .join('')
      .toUpperCase();
  };

  useEffect(() => {
    async function loadInbox() {
      let _res = await getInbox();


      if (_res.success) {
        setInbox(_res.data);
      }

      else if (_res.status === 403) {
        await refresh();

        let _res = await getInbox();

        if (_res.success) {
          setInbox(_res.data);
        }
      }

      setLoaded(true);
    }

    loadInbox();
  }, []);

  async function handleNavigate(id) {
    navigate('/dashboard/message/' + id);
  }

  return (
    <>
      <ScrollToTop />
      <div className='demomessages__demos'>
        <h1 className='buyerdashboard__h1'>Inbox</h1>

        {inbox.length > 0 && (
          <div>
            <div>
              <strong>{inbox.length} Conversations</strong>
            </div>
            <table className='table'>
              <tr>
                <th>Last sent</th>
                <th>From</th>
                <th>Demo status</th>
                <th></th>
              </tr>
              {inbox.map((item, index) => (
                <tr className='demomessages__demo' onClick={() => handleNavigate(item.reference_id)}>
                  {user.registered_user_id === item.buyer_id && (
                    <>
                      <td>
                        {item.last_sent && (
                          <div className="demomessages__last-sent">{new Date(item.last_sent).toLocaleString(undefined, options)}</div>
                        )}
                      </td>

                      <td style={{ width: "330px" }}>
                        <div className="flex items-center">
                          {item.seller_profile_image ? (
                            <span className='demomessages__company-logo'>
                              <img
                                src={baseImageUrl + 'profileimages/' + item.seller_profile_image}
                                alt={item.seller_first_name}
                                className="h-full w-full object-cover"
                              />
                            </span>
                          ) : (
                            <>
                              {item.seller_logo && item.seller_logo.length > 0 ? (
                                <span className="demomessages__company-logo">
                                  <img src={imageUrl + 'tr:di-@@companylogos@@default-buyer.png/' + item.seller_logo} />
                                </span>
                              ) : (
                                <span className="demomessages__company-logo flex items-center justify-center bg-gray-100">
                                  <User className="h-4 w-4 text-gray-500" />
                                </span>
                              )}
                            </>
                          )}

                          <span className='ml-3 flex flex-col justify-center'>
                            <strong className="text-gray-900 font-medium leading-tight">
                              {item.seller_first_name}
                            </strong>
                            {item.seller_company_name && (
                              <span className="text-sm text-gray-600">
                                from {item.seller_company_name}
                              </span>
                            )}
                          </span>
                        </div>
                      </td>

                      <td>
                        <span className={'demomessages__status ' + item.demo_status.toLowerCase()}>{item.demo_status}</span>
                      </td>

                      <td>
                        {item.unread_count > 0 && (
                          <span className="inline-block w-2 h-2 rounded-full bg-purple-500" title="Unread message"></span>
                        )}
                      </td>
                    </>
                  )}

                  {user.registered_user_id === item.seller_id && item.seller_id != item.buyer_id && (
                    <>
                      <td className='demomessages__last-sent'>{new Date(item.last_sent).toLocaleString(undefined, options)}</td>

                      <td>
                         <div className="flex items-center">
                          {item.buyer_profile_image ? (
                            <span className='demomessages__company-logo'>
                              <img
                                src={baseImageUrl + 'profileimages/' + item.buyer_profile_image}
                                alt={item.buyer_first_name}
                                className="h-full w-full object-cover"
                              />
                            </span>
                          ) : (
                            <>
                              {item.buyer_logo && item.buyer_logo.length > 0 ? (
                                <span className="demomessages__company-logo">
                                  <img src={imageUrl + 'tr:di-@@companylogos@@default-buyer.png/' + item.buyer_logo} />
                                </span>
                              ) : (
                                <span className="demomessages__company-logo flex items-center justify-center bg-gray-100">
                                  <User className="h-4 w-4 text-gray-500" />
                                </span>
                              )}
                            </>
                          )}

                          <span className='ml-3 flex flex-col justify-center'>
                            <strong className="text-gray-900 font-medium leading-tight">
                              {item.buyer_first_name}
                            </strong>
                            {item.buyer_company_name && (
                              <span className="text-sm text-gray-600">
                                from {item.buyer_company_name}
                              </span>
                            )}
                          </span>
                        </div>
                      </td>

                      <td>
                        <span className={'demomessages__status ' + item.demo_status.toLowerCase()}>{item.demo_status}</span>
                      </td>

                      <td>
                        {item.unread_count > 0 && (
                          <span className="inline-block w-2 h-2 rounded-full bg-purple-500" title="Unread message"></span>
                        )}
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </table>
          </div>
        )}

        {inbox.length === 0 && loaded === true && (
          <>
            <h2>You have no messages</h2>
          </>
        )}

        {loaded === false && (
          <Spinner />
        )}
      </div>
    </>
  )
}

export default DemoMessages;